<div class="d-flex justify-content-between align-items-center mb-3 head">
    <h5 class="dynamic-preview-heading mb-0">
        {{data?.heading}}
    </h5>
    <img
      src="assets/images/cross-icon.svg"
      alt="cross-icon"
      class="cursor-pointer ml-auto"
      (click)="dialgoRef.close()"
    />
</div>
<app-year-wise [yearData]="data?.stats" *ngIf="data" [config]="data?.config" [canvasId]="data?.id"></app-year-wise>
